import { useDirectorContext } from "@contexts/director";
import QualityBanner from "../QualityBanner";
import { DirectorRouteBreadcrumb } from "../page/DirectorBreadcrumb";
import DirectorFreshnessHeader from "../page/DirectorFreshnessHeader";
import DirectorScopeControls from "../page/DirectorScopeControls";

const EMPTY_QUALITY_SOURCES = [];

// Casca das páginas de Informações complementares: trilha (pelo mapa rota → seção), cabeçalho
// com o estado dos dados e os filtros de empresa e obra. As quatro telas principais usam
// `DirectorPage`, que impõe a ordem pergunta → resposta → gráfico → detalhe → notas.
const ModuleShell = ({
  eyebrow,
  title,
  description,
  badge,
  children,
  className = "",
  qualitySources = EMPTY_QUALITY_SOURCES,
  showProjectFilter = true,
  onPublished,
}) => {
  const { selectedCompanyId, accessByCompany } = useDirectorContext();
  const access = accessByCompany[selectedCompanyId] || {};
  return <main className={`director-page director-module1 ${className}`.trim()}>
    <DirectorRouteBreadcrumb />
    <header className="director-page__header director-module1__header">
      <div>
        <span className="director-eyebrow">{eyebrow || `Diretoria · ${access.companyName || "portfólio"}`}</span>
        <h1>{title}</h1>
        <p>{description}</p>
        <DirectorFreshnessHeader onPublished={onPublished} />
      </div>
      <div className="director-module1__header-actions">
        {badge && <span className="director-module1__badge">{badge}</span>}
        <DirectorScopeControls showProjectFilter={showProjectFilter} />
      </div>
    </header>
    <QualityBanner sources={qualitySources} />
    {children}
  </main>;
};

export default ModuleShell;
